module.exports = __webpack_public_path__ + "static/media/img-contact.9616ca3f.jpg";